var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2311_48344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0202 24.0166C18.5593 24.0166 23.9733 18.5909 23.9733 12.0635C23.9733 5.52441 18.5476 0.110352 12.0085 0.110352C5.4812 0.110352 0.0671387 5.52441 0.0671387 12.0635C0.0671387 18.5909 5.49292 24.0166 12.0202 24.0166ZM12.0202 22.0245C6.48902 22.0245 2.07105 17.5948 2.07105 12.0635C2.07105 6.53223 6.4773 2.10254 12.0085 2.10254C17.5398 2.10254 21.9812 6.53223 21.9812 12.0635C21.9812 17.5948 17.5515 22.0245 12.0202 22.0245Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82886 16.6455L16.4968 12.6962C16.989 12.415 16.9773 11.7353 16.4968 11.4423L9.82886 7.49314C9.32495 7.20017 8.65698 7.42283 8.65698 7.99705V16.1415C8.65698 16.7041 9.27808 16.9736 9.82886 16.6455Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2311_48344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9062,
    height: 23.918,
    fill: "white",
    transform: "translate(0.0671387 0.110352)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.2c048e6fba19d1e3213e92946222580a.svg";
export { ForwardRef as ReactComponent };